/** Cycle 422 — the repeat-cadence band the settings control offers.
 *
 * ONE source of truth on the server: `server/schemas/settings.py`
 * (`ALARM_REPEAT_INTERVAL_FLOOR_SECONDS` / `_CEILING_SECONDS` / `_OPTIONS`).
 * This file mirrors it for the SPA, and `alarmRepeat.test.ts` reads the
 * Python file and turns TS↔Python drift red — the golden-vector pattern.
 *
 * The 30 s and 60 s options this replaces provoked Apple's per-token
 * throttling (2026-08-04) and the 2026-09-02 alert storm. They are gone
 * from the API and the DB as well, not merely from this list, so a client
 * that still sends them gets a 422.
 */
export const ALARM_REPEAT_INTERVAL_FLOOR_SECONDS = 120;
export const ALARM_REPEAT_INTERVAL_CEILING_SECONDS = 1800;
export const ALARM_REPEAT_INTERVAL_DEFAULT_SECONDS = 300;

export interface AlarmRepeatOption {
  /** The `Seg` id — the value in seconds, as a string. */
  id: string;
  seconds: number;
  label: string;
}

/** 2 / 5 / 10 / 15 / 30 min. Ascending, every value inside the band. */
export const ALARM_REPEAT_INTERVAL_OPTIONS: ReadonlyArray<AlarmRepeatOption> = [
  { id: "120", seconds: 120, label: "2 min" },
  { id: "300", seconds: 300, label: "5 min" },
  { id: "600", seconds: 600, label: "10 min" },
  { id: "900", seconds: 900, label: "15 min" },
  { id: "1800", seconds: 1800, label: "30 min" },
];
